app.controller("registerCtrl", [
  "$scope",
  "$ngConfirm",
  "$http",
  "config",
  "checkUser",
  "$localStorage",
  "$location",
  "$rootScope",
  "ngMeta",
  "LocalStorageFactory",
  "cart",
  function (
    $scope,
    $ngConfirm,
    $http,
    config,
    checkUser,
    $localStorage,
    $location,
    $rootScope,
    ngMeta,
    LocalStorageFactory,
    cart
  ) {
    ngMeta.setTitle("Register");

    $scope.unregistered = true;

    let siteConfig = config.fullSite;
    if (
      siteConfig.newslettercheckbox == undefined ||
      siteConfig.newslettercheckbox == "0"
    ) {
      $scope.newslettercheckbox = false;
    } else {
      $scope.newslettercheckbox = true;
    }

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    if (siteConfig.checkout) {
      $scope.registrationMessage =
        siteConfig.checkout.content &&
        siteConfig.checkout.content.registrationMessage;
    }

    if (siteConfig.registrationFields) {
      $scope.extraFields = JSON.parse(siteConfig.registrationFields);
    }

    $scope.shopTitle = siteConfig.shopTitle;
    $scope.registerUser = function () {
      register();
    };
    $(document).on("keydown", function (e) {
      var key = e.which;
      switch (key) {
        case 13: // enter
          if ($scope.shopRegister) {
            if ($scope.shopRegister.$valid) {
              register();
            }
          }
          break;
        default:
          break;
      }
    });

    var registering = false;

    function register() {
      if ($scope.newsletter == undefined) {
        $scope.newsletter = false;
      }
      $("#registerBtn").attr("disabled", true);
      $("#registerBtnText").html("Please Wait...");

      //extras
      var extras = [];
      for (var j = 0; j < $scope.extraFields.length; j++) {
        var val = document.getElementsByClassName("extras")[j].value;
        var name = $scope.extraFields[j].name;
        extras[j] = { name, val };
      }

      if (registering === false) {
        registering = true;
        let siteID = siteConfig.siteID;
        let postdata = {
          email: $scope.email,
          name: $scope.firstName,
          surname: $scope.lastName,
          password: $scope.password,
          shopName: siteConfig.shopTitle, //backwards compatible - for Sarah
          logo: siteConfig.siteLogoURL,
          shopURL: siteConfig.siteURL,
          facebook: siteConfig.facebookLink,
          twitter: siteConfig.twitterLink,
          welcomeText: siteConfig.emailWelcome,
          headerBackgroundColor: siteConfig.headerBackgroundColor,
          newsletter: $scope.newsletter,
          extras: extras,
          siteID: siteID,
        };
        if ($scope.shopRegister.$valid) {
          $http({
            method: "POST",
            url: config.fstreamAPI + "NewCustomer",
            headers: {
              "Content-Type": "application/json", //x-www-form-urlencoded
              Accept: "application/json",
            },
            data: postdata,
          }).then(
            function success() {
              $("#registerBtn").attr("disabled", false);
              $("#registerBtnText").html("Register");

              doLogin($scope.email, $scope.password);
              $scope.unregistered = false;
            },
            function error(response) {
              $("#registerBtn").attr("disabled", false);
              $("#registerBtnText").html("Register");
              if (response.status === 400) {
                registering = false;
                $ngConfirm({
                  title: "Error",
                  content:
                    "It looks like that email address is already in use.<br>Please try another email or login.",
                  scope: $scope,
                  buttons: {
                    close: function () {},
                  },
                });
              } else {
                registering = false;
                $("#registerBtn").attr("disabled", false);
                $("#registerBtnText").html("Register");
                $ngConfirm({
                  title: "Error",
                  content: "There has been a system error",
                  scope: $scope,
                  buttons: {
                    close: function () {},
                  },
                });
              }
            }
          );
        } else {
          registering = false;
          $("#registerBtn").attr("disabled", false);
          $("#registerBtnText").html("Register");
          $ngConfirm({
            title: "Error",
            content: "Please complete the form",
            scope: $scope,
            buttons: {
              close: function () {},
            },
          });
        }
      }
    }

    function doLogin(email, pass) {
      var postdata = {
        email: email,
        password: pass,
        siteID: $localStorage.siteID,
      };
      $http({
        method: "POST",
        url: config.fstreamAPI + "LoginCustomer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: postdata,
      }).then(
        function mySucces(response) {
          $scope.subAlert = false;
          $scope.status = "start";
          $scope.showLoginAlert = false;

          LocalStorageFactory.remove("uuid");
          //create a new uuid, set it to localstorage, update remote pool
          let newUuid = checkUser.getUUID($scope);
          checkUser.setBucketUuids(newUuid);

          const userData = response.data.data;
          checkUser.setUser({
            userId: userData.ID,
            name: userData.Name,
            surname: userData.Surname,
            joined: userData.Joined,
            email: email,
            passwordUpdated: userData.passwordUpdated,
          });

          cart.removeAlreadyOwnedContentFromCart();

          $location.path($location.path()); // what does this do?

          $scope.$parent.loggedIn = true;
          $rootScope.loggedIn = true;
          registering = false;

          if ($localStorage.redirect !== undefined) {
            let tempPath = $localStorage.redirect;
            localStorage.removeItem("redirect");
            window.location.href = tempPath;
          } else {
            $location.path("/tickets");
          }
        },
        function myError(response) {
          toastr.error("Login failed, check Email or Password.", { ttl: 8000 });
          $scope.status = "start";
          $scope.subAlert = true;
          $scope.showLoginAlert = true;
          $scope.loginAlertText = "Error - " + response.data.message;
        }
      );
    }
  },
]);

app.controller("manageAccountCtrl", [
  "$scope",
  "$ngConfirm",
  "$http",
  "$localStorage",
  "$location",
  "checkUser",
  "config",
  "decrypt",
  "ngMeta",
  function (
    $scope,
    $ngConfirm,
    $http,
    $localStorage,
    $location,
    checkUser,
    config,
    decrypt,
    ngMeta
  ) {
    let siteConfig = config.fullSite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    checkUser.verifyLogin(
      () => {},
      () => {
        $location.path("/home");
      }
    );

    ngMeta.setTitle("Account Details");

    $scope.firstName = $localStorage.name;
    $scope.lastName = $localStorage.surname;
    $scope.email = $localStorage.email;
    $scope.customerID = $localStorage.shopUserID;

    // var stillUtc = moment.utc($localStorage.joined).toDate();
    // $scope.joined = moment(stillUtc).local().format('dddd DD MMMM YYYY HH:mm:ss');

    $scope.update = function (form) {
      if (form.$valid) {
        var postdata = {
          email: $scope.email,
          name: $scope.firstName,
          surname: $scope.lastName,
          ID: $scope.customerID,
        };

        $http({
          method: "POST",
          url: config.fstreamAPI + "UpdateCustomer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function success(response) {
            $ngConfirm({
              title: "Success",
              content: "Update Complete",
              scope: $scope,
              buttons: {
                close: function (scope, button) {
                  // closes the modal
                },
              },
            });
            $localStorage.name = $scope.firstName;
            $localStorage.surname = $scope.lastName;
            $localStorage.email = $scope.email;
          },
          function error(response) {
            if (response.status === 400) {
              $ngConfirm({
                title: "Error",
                content:
                  "That email address is already in use.<br>Please try another email.",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            } else {
              $ngConfirm({
                title: "Error",
                content: "System Error",
                scope: $scope,
                buttons: {
                  close: function (scope, button) {
                    // closes the modal
                  },
                },
              });
            }
          }
        );
      } else {
        console.log("form not valid");
      }
    };
  },
]);
